import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resendVerificationPhone, verifyPhoneCode } from "../redux/slices/loginRegister";

const PhoneVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const userId = location.state?.user_id;
  const phone = location.state?.phone;

  const [loading, setLoading] = useState(false);
  const [resent, setResent] = useState(false);
  const [code, setCode] = useState("");
  const [verifying, setVerifying] = useState(false);

  const handleResendCode = () => {
    resendVerificationPhone(userId, phone, setLoading, setResent, toast);
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    if (!code.trim()) {
      toast.error("Please enter the verification code");
      return;
    }

    const result = await verifyPhoneCode(userId, code, setVerifying, toast);

    if (result.success) {
      const existingUser = JSON.parse(localStorage.getItem("user")) || {};
      const updatedUser = {
        ...existingUser,
        phone_verified_at: new Date().toISOString(),
      };
      localStorage.setItem("user", JSON.stringify(updatedUser));

      toast.success("📱 Phone number verified successfully!");
      navigate("/checkout");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 bg-white rounded shadow">
      <p className="mb-4">
        Verification code sent to: <strong>{phone}</strong>
      </p>

      <button
        onClick={handleResendCode}
        disabled={loading || resent}
        className={`mb-6 px-4 py-2 rounded ${
          loading || resent
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-blue-600 text-white hover:bg-blue-700"
        }`}
      >
        {loading ? "Resending..." : resent ? "Code Sent" : "Resend Code"}
      </button>

      <form onSubmit={handleVerifyCode}>
        <label htmlFor="code" className="block mb-2 font-semibold">
          Enter Verification Code
        </label>
        <input
          type="text"
          id="code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="w-full mb-4 px-3 py-2 border rounded"
          placeholder="Enter SMS code"
        />
        <button
          type="submit"
          disabled={verifying}
          className={`w-full px-4 py-2 rounded text-white ${
            verifying
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700"
          }`}
        >
          {verifying ? "Verifying..." : "Verify Code"}
        </button>
      </form>
    </div>
  );
};

export default PhoneVerification;